import { useEffect, useLayoutEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import cls from './SucсessPage.module.scss';
import sberLogo from '@/shared/assets/icons/sberLogoBig.svg';
import { useAcquiringStore } from '../../model/store/useAcquiringStore';
import { Wrapper } from '@/shared/ui/Wrapper';
import { PageLoader } from '@/shared/ui/PageLoader';
import { useCheckPayment } from '../../lib/query/useCheckPayment';
import { $api } from '@/shared/api/axiosInstance';
import { setCookie } from '@/shared/lib/utils/setCookie';

const SucсessPage = () => {
    const { setIsAcquiring } = useAcquiringStore();
    const { mutate, isPending, isSuccess: isCheckSuccess } = useCheckPayment();

    const [searchParams, setSearchParms] = useSearchParams('');

    useLayoutEffect(() => {
        setCookie('acquiringSuccess', 'true', 1);
    }, []);

    const sendCalltouch = async () => {
        await $api.post(
            '/api/policy/call-touch/order',
            {
                sessionId: window?.ct('calltracking_params')?.[0]?.sessionId,
            },
            {
                headers: {
                    'X-Guid': searchParams.get('orderId') as string,
                },
            }
        );
    };

    useEffect(() => {
        if (searchParams.get('orderId') !== null) {
            mutate(searchParams.get('orderId') as string);
        }
    }, [searchParams.size !== 0]);

    useEffect(() => {
        setIsAcquiring(true);
        return () => setIsAcquiring(false);
    }, []);

    useEffect(() => {
        if (isCheckSuccess) sendCalltouch();
    }, [isCheckSuccess]);

    if (isPending) {
        return (
            <Wrapper>
                <PageLoader />
            </Wrapper>
        );
    }

    return (
        <div className={cls.wrapper}>
            <img className={cls.image} src={sberLogo} alt="" />
            <h3>Ваш полис успешно оформлен</h3>
            <p>Страховой полис по вашему договору страхования направлен вам на электронную почту</p>
            <Link to="/" className={cls.btn}>
                Вернуться на главную
            </Link>
        </div>
    );
};

export default SucсessPage;
